import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import CompaniesController from "@/modules/companies/CompaniesController";
import { Permission } from "@forgepoint/shared";
import { useHasAnyPermission } from "@/store/authStore";

export default function Companies() {
  const canViewCompanies = useHasAnyPermission(
    Permission.COMPANIES_VIEW_ALL,
    Permission.COMPANIES_VIEW_OWN,
  );

  if (!canViewCompanies) {
    return (
      <AccessRestricted
        breadcrumbs={[{ label: "Companies", current: true }]}
        message="You do not have permission to view companies."
      />
    );
  }

  return (
    <Layout breadcrumbs={[{ label: "Companies", current: true }]}>
      <CompaniesController />
    </Layout>
  );
}
